<div class="governance-wrapper">
  <div class="governance-container">
    <section id="overview">
      <h1>Governance</h1>
      <p>DOME Governance</p>
      <p>The governance structure for DOME (Recommendations and Registry) ensures strategic direction, alignment with
        community needs, and operational sustainability. Its development and priorities are guided by a formal
        Scientific Advisory Board and continuous input from key international groups within ELIXIR, while also actively
        incorporating feedback from scientific publishers, industry representatives, Machine Learning specialists, and
        data infrastructure experts to ensure broad relevance and effectiveness.</p>
    </section>

    <section id="scientific-advisory-board">
      <h2>Scientific Advisory Board (SAB)</h2>
      <p>The DOME SAB consists of internationally recognized external experts who provide independent strategic advice
        and critical evaluation. The SAB helps ensure that DOME remains aligned with the evolving needs of these diverse
        communities and adheres to best practices in scientific rigor, Machine Learning and Data Stewardship.</p>
      <p><strong>Current SAB Members:</strong> (Updated as of April 2025 - Use placeholders until names are confirmed)
      </p>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <img src="../../assets/sira_0.jpg" alt="Sirarat Sarntivijai" class="member-photo-img">
          </div>
        </div>
        <div class="member-info">
          <h3>Sirarat Sarntivijai </h3>
          <p><strong>Expertise:</strong> Industry & Interoperability </p>
          <p><strong>Affiliation:</strong> Boehringer Ingelheim</p>
          <div class="social-links">
            <a href="https://orcid.org/0000-0002-2548-641X" target="_blank" title="ORCID Profile"><i
              class="bi bi-person-badge"></i></a>

          </div>
        </div>
      </div>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <img src="../../assets/daniel.png" alt="Daniel Garijo" class="member-photo-img">
          </div>
        </div>
        <div class="member-info">
          <h3>Daniel Garijo</h3>
          <p><strong>Expertise:</strong> Academia, AI & Ontologies</p>
          <p><strong>Affiliation:</strong> Universidad Politécnica de Madrid</p>
          <div class="social-links">
            <a href="https://orcid.org/0000-0003-0454-7145" target="_blank" title="ORCID Profile"><i
              class="bi bi-person-badge"></i></a>

          </div>
        </div>
      </div>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <img src="../../assets/Christopher-Hunter.png" alt="Christopher Hunter" class="member-photo-img">
          </div>
        </div>
        <div class="member-info">
          <h3>Chris Hunter</h3>
          <p><strong>Expertise:</strong> Publishing & Open Science</p>
          <p><strong>Affiliation:</strong> GigaScience & GigaDB</p>
          <div class="social-links">
            <a href="https://orcid.org/0000-0002-1335-0881" target="_blank" title="ORCID Profile"><i
              class="bi bi-person-badge"></i></a>

          </div>
        </div>
      </div>
    </section>

    <section id="elixir-ml-focus-group">
      <h2>ELIXIR AI Ecosystem Focus Group</h2>
      <p><strong>Role:</strong> The ELIXIR AI Ecosystem (AIE) Focus Group is a primary source of scientific AI/ML
        expertise and community feedback. DOME originated from this group's prior efforts in the ELIXIR Machine Learning
        Focus Group to address ML reporting challenges in life sciences.</p>
      <p><strong>Influence on DOME:</strong> The AIE Focus Group provides crucial input on the practical needs of
        researchers applying AI/ML, ensuring the DOME Recommendations and Registry features remain relevant to
        scientific practice. Their activities directly inform DOME's technical and conceptual development based on
        real-world use cases.</p>
      <p><a href="https://elixir-europe.org/focus-groups/machine-learning" class="learn-more-link">Learn More</a></p>
    </section>

    <section id="elixir-data-platform">
      <h2>ELIXIR Data Platform</h2>
      <p><strong>Role:</strong> The ELIXIR Data Platform provides strategic context and guidance related to data
        infrastructure best practices within ELIXIR, focusing on FAIR principles, sustainability, and interoperability.
      </p>
      <p><strong>Influence on DOME:</strong> DOME aligns with the Platform's goals for FAIR data resources. Input from
        the Platform helps ensure the DOME Registry adheres to robust technical standards for databases, uses
        recommended interoperability solutions (like Bioschemas, Identifiers.org), and follows best practices for
        sustainable resource management, benefiting from ELIXIR-wide infrastructure expertise.</p>
      <p><a href="https://elixir-europe.org/platforms/data" class="learn-more-link">Learn More</a></p>
    </section>

    <section id="conclusion">
      <p>DOME's development is guided by a transparent governance model that integrates advice from the SAB, dialogue
        with ELIXIR groups, and input from publishers, industry, and experts, ensuring its lasting value to the
        scientific community.</p>
    </section>
  </div>
</div>
<app-big-footer></app-big-footer>

